import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaUserPlus,
  FaTimes,
  FaUser,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaInfoCircle,
  FaTrophy, 
} from "react-icons/fa";
import api from "../../services/axiosInstance"


// ----- Modal for Adding a Professor -----
const AddProfessorModal = ({ isOpen, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    wilaya: "",
    number: "",
    bio: "",
    achievements: "",
  });

  if (!isOpen) return null;

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/users/register-prof", formData);
      onAdd(res.data.user);
      onClose();
      alert("✅ Professeur ajouté avec succès !");
    } catch (error) {
      console.error("Erreur lors de l'ajout :", error);
      alert(error.response?.data?.message || "❌ Erreur lors de l'ajout du professeur");
    }
  };

  return (
     <div
    className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-md flex items-center justify-center px-4"
    onClick={onClose} // 👈 close when clicking outside
  >
    <div
      className="w-full max-w-md bg-white rounded-2xl overflow-hidden shadow-2xl relative"
      onClick={(e) => e.stopPropagation()} // 👈 prevent close when clicking inside
    >    {/* Header */}
        <div className="relative bg-emerald-800 hover:bg-emerald-900 p-6 text-white">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold flex items-center gap-3">
              <div className="p-2 bg-white/20 rounded-lg">
                <FaUserPlus className="text-lg" />
              </div>
              Ajouter un professeur
            </h2>
            <button
              onClick={onClose}
              className="p-2 bg-white/20 hover:bg-white/30 rounded-xl transition-all hover:rotate-90"
            >
              <FaTimes className="text-lg" />
            </button>
          </div>
          <p className="text-blue-100 text-sm mt-2 opacity-90">
            Remplissez les informations du professeur
          </p>
        </div>

        {/* Form */}
        <div className="p-6 max-h-[70vh] overflow-y-auto">
          <form className="space-y-5" onSubmit={handleSubmit}>
            {/* Nom complet */}
            <InputField
              icon={<FaUser />}
              label="Nom complet"
              name="name"
              placeholder="Nom et prénom"
              value={formData.name}
              onChange={handleChange}
              required
            />

            {/* Email */}
            <InputField
              icon={<FaEnvelope />}
              label="Email"
              name="email"
              type="email"
              placeholder="professeur@email.com"
              value={formData.email}
              onChange={handleChange}
              required
            />

            {/* Mot de passe */}
            <InputField
              icon={<FaInfoCircle />}
              label="Mot de passe"
              name="password"
              type="password"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              required
            />

            {/* Wilaya */}
            <InputField
              icon={<FaMapMarkerAlt />}
              label="Wilaya"
              name="wilaya"
              placeholder="Ex: Alger"
              value={formData.wilaya}
              onChange={handleChange}
              required
            />

            {/* Numéro */}
            <InputField
              icon={<FaPhoneAlt />}
              label="Numéro de téléphone"
              name="number"
              placeholder="Ex: 0555 12 34 56"
              value={formData.number}
              onChange={handleChange}
            />

            {/* Bio */}
            <TextAreaField
              icon={<FaInfoCircle />}
              label="Bio"
              name="bio"
              placeholder="Brève description du professeur"
              value={formData.bio}
              onChange={handleChange}
            />

            {/* Achievements */}
            <TextAreaField
              icon={<FaTrophy />}
              label="Réalisations"
              name="achievements"
              placeholder="Ex: Lauréat du concours national..."
              value={formData.achievements}
              onChange={handleChange}
            />

            <button
              type="submit"
              className="w-full bg-emerald-800 hover:bg-emerald-900 
              text-white py-4 rounded-xl font-semibold text-lg hover:shadow-lg 
              transform hover:scale-[1.02] active:scale-[0.98] transition-all"
            >
              Ajouter le professeur
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

// ----- Input Component -----
const InputField = ({ icon, label, name, type = "text", ...props }) => (
  <div className="group">
    <label className="text-sm font-medium text-gray-700 mb-2 block">{label}</label>
    <div className="relative">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
        {icon}
      </div>
      <input
        type={type}
        name={name}
        {...props}
        className="w-full pl-12 pr-4 py-3.5 border-2 border-gray-200 rounded-xl 
        focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
      />
    </div>
  </div>
);

// ----- TextArea Component -----
const TextAreaField = ({ icon, label, name, ...props }) => (
  <div className="group">
    <label className="text-sm font-medium text-gray-700 mb-2 block">{label}</label>
    <div className="relative">
      <div className="absolute left-4 top-4 text-gray-400">{icon}</div>
      <textarea
        name={name}
        rows="3"
        {...props}
        className="w-full pl-12 pr-4 py-3.5 border-2 border-gray-200 rounded-xl 
        focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all resize-none"
      />
    </div>
  </div>
);

// ----- Main Admin Page -----
const AdminProfessors = () => {
  const [professors, setProfessors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ✅ Fetch professors from backend
  useEffect(() => {
    const fetchProfs = async () => {
      try {
        const res = await api.get("/users/get-prof");
        console.log("res.data.professors",res.data.professors)
        setProfessors(res.data.professors);
      } catch (error) {
        console.error("Erreur de chargement :", error);
      }
    };
    fetchProfs();
  }, []);
const handleDeleteProfessor = async (id) => {
  if (!window.confirm("Voulez-vous vraiment supprimer ce professeur ?")) return;

  try {
    await api.delete(`/users/professors/${id}`);

    // Remove from UI
    setProfessors((prev) => prev.filter((p) => p.id !== id));

    alert("Professeur supprimé !");
  } catch (error) {
    console.error("Erreur de suppression :", error);
    alert("Erreur lors de la suppression");
  }
};

  const handleAddProfessor = (newProf) => {
    setProfessors((prev) => [...prev, newProf]);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-5xl mx-auto bg-white p-6 rounded-2xl shadow-md">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            Liste des Professeurs
          </h1>
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 bg-emerald-800 hover:bg-emerald-900 text-white px-5 py-3 rounded-xl font-medium hover:shadow-lg hover:scale-[1.03] transition-all"
          >
            <FaUserPlus />
            <span>Ajouter un professeur</span>
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-emerald-600 hover:bg-emerald-700 text-white">
                <th className="p-3 rounded-tl-xl">Nom</th>
                <th className="p-3">Email</th>
                <th className="p-3">Wilaya</th> 
                <th className="p-3">Numéro</th>
                <th className="p-3">Bio</th>
                <th className="p-3">Réalisations</th>
                <th className="p-3 rounded-tr-xl">Actions</th>
              </tr>
            </thead>
            <tbody>
              {professors.map((prof, index) => (
                <tr key={index} className="border-b hover:bg-gray-50 transition-all">
                  <td className="p-3">{prof.name}</td>
                  <td className="p-3">{prof.email}</td>
                  <td className="p-3">{prof.wilaya}</td>
                  <td className="p-3">{prof.number || "-"}</td>
                  <td className="p-3">{prof.bio || "-"}</td>
                  <td className="p-3">{prof.achievements || "-"}</td>
                  <td className="p-3">
    <button
      onClick={() => handleDeleteProfessor(prof.id)}
      className="px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
    >
      Supprimer
    </button>
  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      <AddProfessorModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAdd={handleAddProfessor}
      />
    </div>
  );
};

export default AdminProfessors;